import React from "react"
import Layout from "../Layout"
import Contact from "../Contact"
import Partners from "../Partners"
import Gallery from "../Gallery"
import Hero from "../Hero"
import Numbers from "../Numbers"
import Summary2023 from "../Summary2023"

const IndexPage = ({ lang }) => (
  <Layout lang={lang}>
    <Hero lang={lang} type="hero2023" />
    <Numbers lang={lang} type="summary2023" />
    <Gallery lang={lang} />
    <Summary2023 lang={lang} />
    <Contact lang={lang} />
  </Layout>
)

export default IndexPage
